import { useParams } from "react-router-dom";
import SortList from "./List.jsx";
import SortDetail from "./Detail";

const SortPage = () => {
    const { secondParam } = useParams();

    const Specified = secondParam ? SortDetail : SortList;

    return <Specified />;
};

export default SortPage;
